import React, { useState, useRef } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Divider, Input, Select, Space, Button, Row, Col } from "antd";
import type { InputRef } from "antd";
import { getCourses } from "../utils/get-emajor";
import { useMount, useUpdateEffect } from "ahooks";

let index = 0;

export const ECourseSelect: React.FC<{
  form: any;
  allValue: any;
  setAllValue: any;
  disabledAll?:boolean;
}> = ({ allValue, form, setAllValue ,disabledAll}) => {
  useMount(() => {
    setAllValue({
      ...allValue,
      eCourse: allValue.eMajor,
    });
    setItems(getCourses(allValue.eMajor));
  });

  useUpdateEffect(() => {
    form.setFieldValue("eCourse", undefined);
    setItems(getCourses(allValue.eMajor));
    setAllValue({
      ...allValue,
      eCourse: undefined,
    });
  }, [allValue.eMajor]);

  const [items, setItems] = useState<any[]>([]);
  const [name, setName] = useState("");
  const inputRef = useRef<InputRef>(null);

  const onNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value);
  };

  const addItem = (
    e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>
  ) => {
    e.preventDefault();
    setItems([...items, name || `New item ${index++}`]);
    setName("");
    setTimeout(() => {
      inputRef.current?.focus();
    }, 0);
  };

  return (
    <Select
      showSearch
      placeholder="Chọn môn học"
      value={allValue.eCourse}
      disabled={disabledAll ? true : false}
      dropdownRender={(menu) => (
        <>
          {menu}
          <Divider style={{ margin: "8px 0" }} />
          {allValue.eMajor && (
            <Space style={{ padding: "0 8px 4px", width: "100%" }}>
              <Row>
                <Col span={22}>
                  <Input
                    placeholder="Nhập môn học"
                    ref={inputRef}
                    value={name}
                    onChange={onNameChange}
                    onKeyDown={(e) => e.stopPropagation()}
                    style={{ width: "100%" }}
                  />
                </Col>

                <Col span={2}>
                  <Button
                    type="text"
                    icon={<PlusOutlined rev="data" />}
                    onClick={addItem}
                  >
                    Thêm môn học
                  </Button>
                </Col>
              </Row>
            </Space>
          )}
        </>
      )}
      options={items.map((item: any) => ({ label: item, value: item }))}
      onChange={(value) => {
        form?.setFieldValue("eCourse", value);
        setAllValue({ ...allValue, eCourse: value });
      }}
    />
  );
};
